import { PurchaseCondition } from '@/models/purchase-condition/purchase-condition';
import { PurchaseConditionsActiveFilters } from '@/modules/purchase-conditions';
import gql from 'graphql-tag';
import { executeQuery } from '../client';

const PURCHASE_CONDITIONS_QUERY = gql`
  query getPurchaseConditions(
    $from: DateTime
    $to: DateTime
    $circuits: [Circuit!]
    $supplierCode: Int
    $supplierCorpName: String
  ) {
    purchaseConditions(
      from: $from
      to: $to
      circuits: $circuits
      supplierCode: $supplierCode
      supplierCorpName: $supplierCorpName
    ) {
      ... on BasePurchaseCondition {
        id
        superSupplierCode
        superSupplierCorpName
        legalSupplierCode
        supplierCode
        supplierCorpName
        ean
        supplierRef
        ref
        designation
        beginDate
        currency
        billingUnit
        circuit
        incoTerm
        pcbPackaging
        francoAmount
        francoUnit
        grossPrice
        cgvDiscount
        otherCgvDiscount
        cpvDiscount
        netPrice
        ecoParts {
          d3eLight
          d3eElec
          deaFourniture
          pmcb
        }
        matrixName
        insertionDate
      }
      ... on LDDPurchaseCondition {
        transportPrice
        netPriceWithoutTransportPrice
      }
      ... on WarehousePurchaseCondition {
        multiplePCB
        logisticDiscount
      }
    }
  }
`;

export async function getPurchaseConditions(filters: PurchaseConditionsActiveFilters): Promise<PurchaseCondition[]> {
  const { purchaseConditions } = await executeQuery<{ purchaseConditions: PurchaseCondition[] }>(
    PURCHASE_CONDITIONS_QUERY,
    filters
  );

  return purchaseConditions;
}
